import React from 'react';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';

import styled from 'styled-components';

import { toggleModal, toggleModalWithTimer, toggleSpinner } from 'apps/auth/actions/appAction';
import { setExtra } from 'apps/auth/actions/extraAction';
import { DangerouslyHtml } from 'apps/auth/components/common/DangerouslyHtml/DangerouslyHtml';
import PopupButton from 'apps/auth/components/common/Popup/PopupButton';
import SimplePopup from 'apps/auth/components/common/Popup/SimplePopup';
import { AUTH_GA_TERMS_CONFIRM } from 'apps/auth/constants/UrlConstants';
import { apiFetchData } from 'apps/auth/helpers/api';

const PopupText = styled.div`
    p {
        margin-bottom: 0;
    }
`;
const TcPopup = (props) => {
    const closeModal = () => {
        props.toggleModal(false).then(() => props.toggleModalWithTimer(false, '', false));
    };

    const requestToServer = (e) => {
        e.preventDefault();
        props.toggleSpinner(true);
        props.popupRef.current?.close();
        apiFetchData(AUTH_GA_TERMS_CONFIRM)
            .then((json) => {
                if (json) {
                    if (json.extra) {
                        props.setExtra(json.extra);
                    }
                }
                props.toggleSpinner(false).then(() => props.toggleModalWithTimer(true, props.accountsAdded, closeModal));
            })
            .catch(() => {
                props.toggleSpinner(false);
            });
    };

    const correctTextAgree = props.textAgree.replace(/className/, 'class');

    const getText = (text) => {
        return (
            <PopupText>
                <DangerouslyHtml dangerouslyHtml={text} />
            </PopupText>
        );
    };

    return (
        <SimplePopup text={getText(correctTextAgree)} popupRef={props.popupRef}>
            <PopupButton iconName="arrow-forward" text={props.continueButton} onClick={requestToServer} />
        </SimplePopup>
    );
};
const mapStateToProps = (state) => {
    return {
        continueButton: state.messages.pageMessages.continueButton,
        textAgree: state.messages.pageMessages.textAgree,
        accountsAdded: state.messages.pageMessages.accountsAdded,
    };
};
TcPopup.propTypes = {
    continueButton: PropTypes.string.isRequired,
    textAgree: PropTypes.string.isRequired,
};
export default connect(mapStateToProps, {
    setExtra,
    toggleModal,
    toggleModalWithTimer,
    toggleSpinner,
})(TcPopup);
